import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiModule } from '../shared-ui/shared-ui.module';
import { RouterModule, Routes } from '@angular/router';

import { UserLoginComponent } from './user-login/user-login.component';
import { UserSignupComponent } from './user-signup/user-signup.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { OtpComponent } from './otp/otp.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  { path: 'login', component: UserLoginComponent },
  { path: 'signup', component: UserSignupComponent },
  { path: 'forgetPassword', component: ForgetPasswordComponent },
  { path: 'changePassword', component: ChangePasswordComponent },
  { path: 'otp', component: OtpComponent },
  { path: 'reset-password', component: ResetPasswordComponent }
];

@NgModule({
  declarations: [
    UserLoginComponent,
    UserSignupComponent,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    OtpComponent,
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    SharedUiModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    UserLoginComponent,
    UserSignupComponent,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    OtpComponent,
    ResetPasswordComponent
  ]
})
export class AuthModule { }
